// helpers
import { normalizeDate } from 'shared/helpers/utils';

export const getValidDate = (date: string) => {
  if (!date) return '';

  return normalizeDate(date).toLocaleDateString('en-GB');
};
